<template>
  <ul class="mainUl">
    <li
      v-for="(item, index) in flowInfo"
      :key="index"
      :class="{ next: index !== flowInfo.length - 1 && +orderFlag === 1 }"
    >
      <template>
        <div class="people">
          <img :src="fileOperShow(item.imgPath)" v-if="item.imgPath" />
          <template v-else>
            <!--  <img src="../../static/images/touxiang66dark.png" class="photo" v-if="+item.flowStatus!==0">-->
            <img src="/images/web/p-default1.png" />
          </template>
        </div>
        <p
          :title="item.partyName || item.corpUserName || getName(item)"
          class="p1"
        >
          {{
            item.partyName || item.corpUserName || getName(item) || item.name
          }}
        </p>
      </template>
      <div v-show="item.hasSend">
        <p
          :class="[
            'p2',
            { danger: item.flowStatus === 2, agree: item.flowStatus === 1 },
          ]"
        >
          {{ txtChange(item.flowStatus) }}
        </p>
        <p class="p-date" style="margin-bottom: 10px">
          {{ item.flowTime | format }}
        </p>
        <el-tooltip
          effect="dark"
          placement="top-start"
          v-show="item.flowStatus === 2"
        >
          <p slot="content" style="width: 200px; line-height: 1.5">
            {{ item.refuseReason || '无' }}
          </p>
          <span style="cursor: default">
            <span class="danger" v-if="!isInDingTalk"> 拒绝原因 </span>
          </span>
        </el-tooltip>
        <p
          class="btn1"
          v-if="
            !showTipBtn() &&
            item.flowStatus === 0 &&
            prevItemFn(item) &&
            !isInDingTalk
          "
        >
          <el-button
            size="mini btn-margin btn-red-border"
            v-if="!item.tip && timeOverFn(item)"
            @click="handleTip(item)"
            >提醒</el-button
          >
          <el-button size="mini btn-margin btn-gray" type="info" v-else
            >已提醒</el-button
          >
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import { fileOperShow } from '@/assets/js/http-serve/http-methods';
import { isInDingTalk } from '@/assets/js/utils/ding-env';
export default {
  name: 'approval-process',
  props: {
    flowInfo: {
      type: Array,
    },
    orderFlag: Number,
  },
  data () {
    return {
      isInDingTalk,
      fileOperShow: fileOperShow
    }
  },
  created () {
  },
  methods: {
    handleTip (item) {
      item.tip = true;
      this.$emit('handleTip', item.id);
    },
    txtChange (flowStatus) {
      // flowStatus字段有调整，钉钉耦合的也要处理
      const txts = ['待审批', '已通过', '已驳回'];
      return txts[flowStatus];
    },
    //提醒节流
    timeOverFn (obj) {
      let nowTime = new Date().getTime();
      let updateTime = obj.updateTime;
      let oldTime = new Date(updateTime).getTime();
      return nowTime - oldTime > 1000 * 60 * 60
    },
    //前一个是否通过
    prevItemFn (obj) {
      let k = this.flowInfo.findIndex((item) => {
        return item.id === obj.id;
      })
      if (k === 0) {
        return true;
      } else {
        return this.flowInfo[k - 1].flowStatus === 1;
      }
    },
    showTipBtn () {
      return this.flowInfo.some(i => i.flowStatus === 2);
    },
    getName (item) {
      const names = ['一级主管', '二级主管', '三级主管', '四级主管', '五级主管', '六级主管', '七级主管', '八级主管', '九级主管', '十级主管'];
      return names[item.targetId - 1];
    },
  },
};
</script>

<style scoped lang="less">
.danger {
  color: #ec1c1c;
}

.agree {
  color: #009899;
}

.mainUl {
  width: 100%;
  display: inline-block;

  li {
    text-align: center;
    width: 80px;
    position: relative;
    margin-right: 50px;
    float: left;

    .people {
      margin: 20px auto 5px auto;
      img {
        width: 65px;
        height: 65px;
        border-radius: 50%;
      }
    }

    .p1 {
      margin-bottom: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: rgba(41, 2, 2, 1);
    }

    .p2 {
      margin-bottom: 10px;
    }
    .btn-margin {
      margin: 7px 0;
    }
  }

  .next:after {
    content: "";
    background: url("/images/web/next.png") no-repeat;
    background-size: contain;
    width: 30px;
    height: 25px;
    display: inline-block;
    position: absolute;
    right: -40px;
    top: 40px;
  }
}

.green {
  color: #009899;
}

.red {
  color: #ec1c1c;
}

.btn-red-border {
  background: #fff;
  color: #ec1c1c;
  border: 1px solid #ec1c1c;
}

.btn-red-border:hover {
  background: #ec1c1c;
  color: #fff;
}

.btn-gray,
.btn-gray:hover {
  background: #e6e6e6;
  color: #9a9a9a;
  border: #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// components/approval-process/index.vue